export default {"src":"/_next/static/media/buy-icon.1e11fa79.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};